import React, { Component } from "react";
import ReactDOM from "react-dom";
import moment from "moment";
import {
  Button,
  Input,
  InputGroup,
  Collapse,
  InputGroupAddon,
  Modal,
  ModalBody,
} from "reactstrap";
import Select from "react-select";
import Plotly from "plotly.js-basic-dist";
import ChartListItem from "./ChartListItem";
import { saveAs } from "file-saver";
import { withRouter, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { getFlatDataFromTree, getTreeFromFlatData } from "react-sortable-tree";
import {
  analyticsCategoryFilterValues,
  chartMarkerSymbolsVariation,
  chartMarkerSymbols,
  dtickFormat,
  chartLineColor,
  plotlyMarkerTypes,
  benchmarkLineTypes,
  getAppliedFiltersCount,
  findNodeinHierarchy,
  KPISbyMonth,
  privacyLabel,
  checkNoDataLayoutValidity,
  getEmptyGraphLayoutObject,
  getAvgTenureFormatted,
} from "../../../utils/constants";
import {
  canEditChart,
  canArchiveChart,
} from "./../../../utils/privacySettings";
import InfoMessage from "./../../../components/Message/InfoMessage/InfoMessage";
import EmptyTable from "./../../../components/EmptyTable/EmptyTable";
import find from "lodash/find";
import findIndex from "lodash/findIndex";
import filter from "lodash/filter";
import sortBy from "lodash/sortBy";
import reverse from "lodash/reverse";
import pick from "lodash/pick";
import uniqBy from "lodash/uniqBy";
import axios from "./../../../axios";
import * as url from "./../../../utils/url";
import { chartKpiDataFieldRefTransformationMultipleCharts, generateLegendTitle } from "./../../../utils/chartUtils";
import NoFavoritesPlaceholder from "./../../../assets/toolkit-favorite-placeholder.svg";
import NoKpiPlaceholder from "./../../../assets/placeholders/no_kpi_available.svg";
import KpiAvailablePlaceholder from "./../../../assets/placeholders/kpi_available.svg";
import html2canvas from "html2canvas";
import ChartListItemOptions from "./ChartListItemOptions";
import DrillDown from "./DrillDown/DrillDown";
import * as actionCreators from "./../../../modules/actions/index";
import drillDownClose from "./../../../assets/drilldown_close.svg";
import {
  analyticsCategories,
  getAnalyticsNameById,
  archiveChart,
} from "../../../utils/categories";
import Loading from "../../../hoc/Loading/Loading";
import { deepClone } from "../../../utils/copyObject";
import { socketConnection } from "../../../socketClient";
import Tooltip from "../../../components/UI/TooltipIcon/TooptipIcon";
import KPIDescriptionModal from "./KPIDescriptionModal";
import template from "lodash.template";
import AssigneeDropdown from "../../weekly-wins/AssigneeDropdown";
import { isEmpty } from "lodash";

class ChartList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      kpiList: [],
      displayCharts: [],
      // allCharts: [],
      displayType: "display",
      noSearchResults: false,
      isScroll: false,
      isFilterCollapsed: false,
      filters: {},
      copyFilters: [
        "name",
        "benchmarkData.location",
        "benchmarkData.benchmarkType.type",
        "startDate",
        "endDate",
        "useLatestDataAvailable",
        "selectedOffice",
        "invitedUsers",
        "hierarchyVersion",
        "kpiRecords",
        "kpiType",
        "kpiData",
        "category",
      ],
      analyticsCategory: "",
      selectedSort: "last-updated",
      searchedTerm: "",
      showKPIDescriptionModal: false,
      flatHierarchy: getFlatDataFromTree({
        treeData: this.props.user.profile.organizationId.staticHierarchy.map(
          (e) => ({ label: e.title, value: e.officeKey, ...e })
        ),
        getNodeKey: ({ node }) => node.officeKey,
        ignoreCollapsed: false,
      }).map(({ node }) => {
        return {
          label: node.title,
          value: node.officeKey,
          nodeId: node.id,
          archivedOfficeNames: node.archivedOfficeNames
            ? node.archivedOfficeNames.map((e) => e.title)
            : [],
        };
      }),
      legendData: [],
      isBenchmark: false,
      chartLength: 0,
      pageNumber: 0,
      isChartsLoaded: false,
      yRange: [-0.05, 1.01],
      notificationChart: false,
      isContinue: true,
      categoryValue: "",
      chartMessage: "",
      officeNode: null,
      chartCount: 0,
      searchCharts: [],
      dashboardOptions: [],
      assignedUser: null,
    };
    this.chartItemsRef = [];

    this.timer = null;
  }

  selectUser = (data) => {
    this.setState({ assignedUser: data });
  };

  getChartId = () => {
    // console.log(this.props)/
    let urlStr =
      this.props.history.location &&
      this.props.history.location.search &&
      this.props.history.location.search.length > 0
        ? this.props.history.location.search
        : "";

    if (urlStr && urlStr.length > 0 && urlStr.indexOf("chartId") > -1) {
      let val = urlStr.split("chartId=")[1];
      let chartId = val.split("&")[0];

      return chartId;
    } else {
      return false;
    }
  };

  componentDidMount() {
    const that = this;
    window.addEventListener("beforeunload", this.handleBeforeUnload);
    let hierarchy = this.props.user.profile.organizationId.staticHierarchy;
    let officeKey = this.props.user.profile.officeKey;
    // console.log('officekey---', officeKey)
    let officeNode = findNodeinHierarchy(hierarchy, officeKey);
    let chartId;
    // console.log('offices----',officeNode)
    //
    // this.setState({chartMessage:""})
    let benchBool =
      this.props.history.location.pathname.indexOf("compensation") > -1 ||
      this.props.history.location.pathname.indexOf("compensation") > -1;

    // this.setState({
    //               isBenchmark: benchBool,
    //               chartMessage:"",
    //               officeNode
    //           })

    let { category } = this.props.match.params;
    // console.log(category, this.props)
    // category = category.replace(/\+/g, ' ');
    let mappedValue =
      find(analyticsCategories, { name: category }) ||
      find(analyticsCategories, { link: category });

    if (!mappedValue || mappedValue == undefined) {
      let urlArray = this.props.location.pathname.split("/");
      let urlCat = urlArray[urlArray.length - 1].replace(/\+/g, " ");
      mappedValue = find(analyticsCategories, { name: urlCat });
    }

    // console.log("props----", this.props)

    // const {kpiMasterList} = this.props.kpiMaster;
    // console.log(this.props)
    const { mappingMasterList } = this.props.mappingMaster;
    const { organizationId } = this.props.user.profile;

    if (mappingMasterList.length === 0) {
      axios
        .get(url.getExistingMappings(organizationId._id))
        .then(({ data }) => {
          const payload = data.data;
          this.props.onMappingMasterListFetched(payload.mapping);
        });
    }
    this.setState({
      isBenchmark: benchBool,
      chartMessage: "",
      officeNode,
    });

    this.setState({
      isLoading: true,
      analyticsCategory: mappedValue.link,
      categoryValue: mappedValue.name,
      isBenchmark: benchBool,
      chartMessage: "",
      officeNode,
    });

    this.getKpiListForCategory(mappedValue);

      axios
        .get(
          url.fetchAnalyticsByCategory(mappedValue.name, 0, this.getChartId())
        )
        .then(({ data }) => {
          // console.log(data.data)
          let isBench = data.data.benchmarkDataAvailable;
          let isData = data.data.kpiDataAvailable || data.data.length > 0;
          const industriesListApi = data.data.industryArr ? data.data.industryArr : data.meta.industryArr
          this.setState({
            pageNumber: 0,
            chartLength: data.meta.length,
            chartCount: data.meta.chartCount,
            notificationChart: data.meta.notificationChart
              ? this.processKpiData([data.meta.notificationChart])
              : false,
            chartMessage: "",
            industriesList:industriesListApi
          });
          // console.log('data-----', data)

          if (category === "favorites") {
            const { favList, favRemovedCount } = data.data;
            let charts = favList;
            let updatedCharts = this.processKpiData(charts);
            // this.setState({chartLength: favList.length})

            updatedCharts = reverse(
              sortBy(updatedCharts, [
                function(chart) {
                  return chart.lastUpdate.dateTime;
                },
              ])
            );
            this.setState({
              displayCharts: updatedCharts,
              // allCharts: updatedCharts,
              favRemovedCount: favRemovedCount,
              isLoading: false,
            });
          } else if (Array.isArray(data.data)) {
            // console.log("charts ARRAY")
            let charts = data.data;
            // console.log('charts---', charts)
            let updatedCharts = this.processKpiData(charts);
            // console.log('updated---', updatedCharts)
            updatedCharts = reverse(
              sortBy(updatedCharts, [
                function(chart) {
                  // console.log('char--------', chart)
                  return chart.lastUpdate.dateTime;
                },
              ])
            );
            // console.log('dis---', updatedCharts)

            this.setState({
              displayCharts: updatedCharts,
              isKpiDataAvailableForCategory: isData,
              isBenchmarkDataAvailableForCategory: isBench,
              // allCharts: updatedCharts,
              isLoading: false,
            });
          } else {
            const { benchmarkDataAvailable, kpiDataAvailable } = data.data;
            this.setState({
              displayCharts: [],
              // allCharts: [],
              isKpiDataAvailableForCategory: isData,
              isBenchmarkDataAvailableForCategory: isBench,
              isLoading: false,
            });
          }
        })
        .catch((error) => {
          //todo show error
        })
        .finally(() => {
          // if (
          //   this.state.allCharts.length ||
          //   this.state.displayCharts.length === 0
          // ) {
          this.setState({ isChartsLoaded: true });
          // }
        });


    this.isDashboardChart();
  }

  isDashboardChart = () => {
    let { organizationId } = this.props.user.profile;
    axios
      .post(url.getDashboardList, {
        organizationId: organizationId._id,
        isEditOnly: true,
        noLoader:true
      })
      .then((response) => {
        let list = response.data.data.map((e) => {
          return { id: e._id, name: e.name };
        });
        this.setState({ dashboardOptions: list });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  componentWillMount() {
    let search = this.props.location.search;
    let paramCategory = this.props.match.params.category.replace(/\+/g, " ");

    if (!paramCategory || paramCategory == undefined) {
      let urlArray = this.props.location.pathname.split("/");
      let urlCat = urlArray[urlArray.length - 1].replace(/\+/g, " ");
      paramCategory = find(analyticsCategories, { name: urlCat });
    }
    // console.log('pram--', paramCategory)

    if (!this.state.officeNode) {
      let hierarchy = this.props.user.profile.organizationId.staticHierarchy;
      let officeKey = this.props.user.profile.officeKey;
      let officeNode = findNodeinHierarchy(hierarchy, officeKey);
      // console.log('offnode--', officeNode)
      this.setState({ officeNode });
    }
    if (search !== "") {
      let link = "";
      for (let category of analyticsCategories) {
        if (category.name === paramCategory) {
          link = category.link;
        }
      }
      if (link !== "") {
        this.props.history.push({
          pathname: "/home/analytics/" + link,
          search: search,
        });
        window.location.reload();
      }
    }
  }

  getKpiListForCategory = ({ name }) => {
    axios
      .get(url.getCategoryKpiList + name,{noLoader:true})
      .then((response) => {
        if (response && response.data.meta.success) {
          let kpiList = response.data.data;
          kpiList = kpiList.map((kpi) => {
            return {
              id: kpi._id,
              name: kpi.name,
              definition: kpi.definition,
              code: kpi.code,
            };
          });
          this.setState({ kpiList: kpiList });
        }
      })
      .catch((error) => {});
  };

  handleAddToFavorite = (chartId, isFavorite) => {
    const { analyticsCategory } = this.state;
    const { displayCharts } = this.state;
    let client, link;
    if (analyticsCategory === "favorites" || isFavorite) {
      link = url.removeFromFavoritesChart(chartId);
      client = axios.delete(link);
    } else {
      link = url.addToFavoritesChart(chartId);
      client = axios.post(link);
    }
    client
      .then(({ data }) => {
        if (analyticsCategory === "favorites") {
          const i = findIndex(displayCharts, { _id: chartId });
          const chart = displayCharts[i];

          // Socket call for Saving KPI Name.
          // socketConnection.track("Chart_Remove_From_Favorite_Click", {
          //   kpiName : chart.kpiData.map((o) => o.kpiId.name)
          // });
          let newLength = this.state.chartLength - 1;
          displayCharts.splice(i, 1);
          this.setState({
            displayCharts: displayCharts,
            chartLength: newLength,
          });
        } else {
          const i = findIndex(displayCharts, { _id: chartId });
          const chart = displayCharts[i];

          // Socket call for Saving KPI Name.
          // socketConnection.track("Chart_Add_To_Favorite_Click", {
          //   kpiName : chart.kpiData.map((o) => o.kpiId.name)
          // });

          const updatedChart = { ...chart, isFavorite: !isFavorite };
          displayCharts.splice(i, 1, updatedChart);
          this.setState({
            displayCharts: displayCharts,
          });
        }
      })
      .catch((error) => {
        //todo show error
      });
  };

  handleArchive = (chartId) => {
    const { displayCharts, searchCharts } = this.state;
    const index = findIndex(displayCharts, { _id: chartId });
    const chart = displayCharts[index];

    axios
      .put(url.archiveChart(chartId))
      .then(({ data }) => {
        chart.isArchive.value = true;
        // Socket call for Saving KPI Name.
        // socketConnection.track("Archive_Chart_Click", {
        //   kpiName : chart.kpiData.map((o) => o.kpiId.name)
        // });

        let updateObject = {
          chartLength: this.state.chartLength - 1,
        };

        if (this.state.analyticsCategory !== "favorites") {
          displayCharts.splice(index, 1);
          updateObject.displayCharts = displayCharts;

          // if (searchCharts.length > 0) {
          //   const searchInd = findIndex(searchCharts, { _id: chartId });
          //   searchCharts.splice(searchInd, 1);
          //   updateObject.searchCharts = searchCharts;
          // }
        }

        this.setState(updateObject);
      })
      .catch((error) => {
        //todo show error
      });
  };

  handleEdit = (chartId, data) => {
    const analyticCategory = this.props.match.params.category.replace(
      /\+/g,
      " "
    );

    let { displayCharts } = this.state;
    // let aggCharts = [...allCharts, ...searchCharts];
    let aggCharts = [...displayCharts];

    // const {allCharts} = this.state;
    let editChart = find(aggCharts, { _id: chartId });

    editChart = { ...editChart, lockedDate: data.lockedDate };

    const category =
      find(analyticsCategories, { link: editChart.category }) ||
      find(analyticsCategories, { name: editChart.category });

    // localStorage.setItem('chartNavigationFlow', 'edit');
    this.props.history.push({
      pathname: `/home/analytics/${category.link}/edit`,
      state: editChart,
      fromPath: "edit",
    });
  };

  handleChartRecreate = (chartId) => {
    const analyticCategory = this.props.match.params.category.replace(
      /\+/g,
      " "
    );
    let { displayCharts } = this.state;
    // let aggCharts = [...allCharts, ...searchCharts];
    let aggCharts = [...displayCharts];
    let pickedChart = find(aggCharts, { _id: chartId });
    let copyChart = pickedChart;
    // pick(pickedChart,)
    // console.log(copyChart, aggCharts)
    // return
    copyChart.kpiData.map((e) => (e.score = []));
    copyChart.isCopied = true;
    let copyName = "COPY of " + copyChart.name;
    copyChart.name = copyName;

    // console.log(copyChart)

    // return
    // console.log(analyticCategory)
    const category =
      find(analyticsCategories, { link: copyChart.category }) ||
      find(analyticsCategories, { name: copyChart.category });
    // console.log(category)
    this.props.history.push({
      pathname: `/home/analytics/${category.link}/create`,
      state: {
        category: category.name,
        copyChart,
        isCopied: copyChart.isCopied,
      },
    });
  };

  // handleChartRecreate = (chartId) => {
  //     const analyticsCategory = this.props.match.params.category;
  //     const category = find(analyticsCategories,{link : analyticsCategory});
  //     let {allCharts,copyFilters} = this.state;
  //     let pickedChart = find(allCharts,{_id : chartId});
  //     let copyChart = pick(pickedChart, copyFilters)

  //     // localStorage.setItem('chartNavigationFlow', 'create');
  //     this.props.history.push({
  //       pathname: `/home/analytics/${analyticsCategory}/create`,
  //       state : copyChart,
  //       category : category.name
  //       // fromPath : 'recreate'
  //     });
  // }

  formatFilterPayload = (filters) => {
    let filterPayload = {};
    if (filters["chartCreatedBy"]) {
      // let filteredList = [];
      // list.forEach((chart) => {
      //   if (
      //     filters.chartCreatedBy &&
      //     chart.createdBy &&
      //     chart.createdBy._id == filters.chartCreatedBy._id
      //   ) {
      //     filteredList.push(chart);
      //   }
      // });
      // console.log(filteredList);
      // filteredList = uniqBy(filteredList, "_id");
      // list = deepClone(filteredList);

      filterPayload["createdBy"] = filters["chartCreatedBy"]._id;
    }
    if (
      filters["createdBy"] &&
      filters["createdBy"].length > 0 &&
      !find(filters["createdBy"], { value: "All" })
    ) {
      // let filteredList = [];
      // list.forEach((chart) => {
      //   if (find(filters["createdBy"], { value: "PRIVATE" })) {
      //     if (chart.createdBy._id === _id) {
      //       filteredList.push(chart);
      //     }
      //   }

      //   if (find(filters["createdBy"], { value: "CUSTOM" })) {
      //     chart.invitedUsers.filter((e) => {
      //       if (e.value == profile._id) {
      //         filteredList.push(chart);
      //       }
      //     });
      //   }

      //   if (find(filters["createdBy"], { value: "ENTERPRISE" })) {
      //     if (chart.privacy === "ENTERPRISE") {
      //       filteredList.push(chart);
      //     }
      //   }

      //   // if(find(filters['createdBy'],{value : "OFFICE_AND_CHILDREN"})) {
      //   //   if(chart.createdBy.officeId !== userOfficeId && chart.privacy === "OFFICE_AND_CHILDREN") {
      //   //     filteredList.push(chart);
      //   //   }
      //   // }
      // });

      filterPayload["privacy"] = filters["createdBy"]
        .map((x) => x.value)
        .join(",");
    }

    if (filters["category"] && !filters["category"].includes("All")) {
      // list = filter(list, (chart) => {
      //   if (
      //     chart["category"] &&
      //     filters["category"].includes(chart["category"])
      //   ) {
      //     return true;
      //   }
      // });
      const catData = filters["category"];
      if (Array.isArray(catData)) {
        filterPayload["category"] = filters["category"]
          .map((x) => x.value)
          .join(",");
      } else {
        filterPayload["category"] = catData;
      }
    }

    if (filters["office"] && filters["office"].length > 0) {
      // list = filter(list, (chart) => {
      //   if (chart.selectedOffice && chart.selectedOffice.value) {
      //     if (
      //       filters["office"].filter(
      //         (e) => e.value === chart.selectedOffice.value
      //       ).length > 0
      //     ) {
      //       return true;
      //     }
      //   } else if (!chart.selectedOffice && chart.officeId) {
      //     let path = chart.officeId.officeHierarchyPath.split("#");
      //     let chartName = path[path.length - 1];
      //     if (
      //       chartName &&
      //       filters["office"].filter((e) => e.nodeId === chartName).length > 0
      //     ) {
      //       return true;
      //     }
      //   }
      // });

      filterPayload["office"] = filters["office"]
        .map((e) => {
          console.log("value_value", e);
          return e.value;
        })
        .join(",");

      filterPayload["office_labels"] = filters["office"]
        .map((e) => {
          console.log("label_label", e);
          return e.label;
        })
        .join(",");
    }

    return filterPayload;
  };

  filterData = async (filters) => {
    // let filterPayload = this.formatFilterPayload(filters)
    // console.log(list);
    // return list;

    this.getMoreCharts(filters, true);
  };

  sortData = (displayCharts, sortType) => {
    let list = [];
    if (sortType === "a-z") {
      list = sortBy(displayCharts, [
        function(chart) {
          return chart.name;
        },
      ]);
    } else if (sortType === "z-a") {
      list = reverse(
        sortBy(displayCharts, [
          function(chart) {
            return chart.name;
          },
        ])
      );
    } else if (sortType === "last-updated") {
      list = reverse(
        sortBy(displayCharts, [
          function(chart) {
            return chart.lastUpdate.dateTime;
          },
        ])
      );
    }
    return list;
  };

  handleSortSelected = (sortType) => {
    const { displayCharts } = this.state;
    const list = this.sortData(displayCharts, sortType);
    this.chartItemsRef = [];
    this.setState({ displayCharts: list, selectedSort: sortType });
  };

  searchInputDelay = ({ target }) => {
    let { value } = target;
    let { searchedTerm } = this.state;
    // this.setState({customUser:value})
    // let result = value.replace(/^\s+|\s+$/g, '')
    // console.log('result----',result)
    let s_value = value.replace(/^\s+|\s+$/g, "");
    let s_term = searchedTerm.replace(/^\s+|\s+$/g, "");
    if (s_value != s_term) {
      this.setState({ searchedTerm: value }, () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.getMoreCharts(this.state.filters, true);
        }, 2000);
      });
    }
  };

  handleSearchQueryChanged = (value) => {
    // let {name,value} = target;
    // const {filters,allCharts,selectedSort, categoryValue} = this.state;
    // this.setState({})
    // let list = [];

    // list = this.filterData(filters);
    // this.setState({searchedTerm: value})
    // .replace(/^\s+|\s+$/g, '')
    if (value && value.length !== 0) {
      axios
        .get(
          url.searchAnalyticsByCategory(
            this.state.categoryValue,
            encodeURIComponent(value)
          )
        )
        .then(({ data }) => {
          if (data && data.data && data.data.length > 0) {
            // console.log('results-----',data.data)
            let updatedCharts = this.processKpiData(data.data);
            updatedCharts = reverse(
              sortBy(updatedCharts, [
                function(chart) {
                  return chart.lastUpdate.dateTime;
                },
              ])
            );
            // console.log('updatedCharts: ', updatedCharts)
            this.setState((prevState) => ({
              // searchCharts: updatedCharts,
              noSearchResults: false,
              displayType: "search",
              // displayCharts: [...updatedCharts, ...prevState.displayCharts]
            }));
          } else {
            this.setState({
              // searchCharts: [],
              noSearchResults: true,
              displayType: "search",
            });
          }
        })
        .catch((error) => {
          //todo show error
        });
    } else {
      this.setState({
        // searchCharts: [],
        noSearchResults: false,
        searchedTerm: "",
        displayType: "display",
      });
    }
  };

  handleFilterSelected = (value, type) => {
    const { filters, allCharts, searchedTerm, selectedSort } = this.state;
    // console.log(value)

    filters[type] = value;

    this.filterData(filters);
    // if (searchedTerm.length > 0) {
    //   list = filter(list, (chart) =>
    //     chart.name.toLowerCase().includes(searchedTerm)
    //   );
    // }
    // list = this.sortData(list, selectedSort);
    this.setState({
      filters: filters,
      // searchCharts: list,
      // displayCharts : list,
      // searchCharts: list
      // displayType: "search",
    });
  };

  handleClearFilters = () => {
    // console.log('all--', allCharts)
    // const { allCharts, searchedTerm, selectedSort } = this.state;
    // let list = allCharts;
    // if (searchedTerm.length > 0) {
    //   list = filter(allCharts, (chart) => chart.name.includes(searchedTerm));
    // }
    // list = this.sortData(list, selectedSort);
    this.setState(
      {
        // searchCharts: [],
        filters: {},
      },
      () => {
        this.getMoreCharts({}, true);
      }
    );
  };

  toggleCollapse = () => {
    const { isFilterCollapsed } = this.state;
    this.setState({ isFilterCollapsed: !isFilterCollapsed });
  };

  handleExportAsPng = (chartId, plotRef) => {
    // console.log(this.chartItemsRef)
    const chartItem = find(this.chartItemsRef, (ref) => {
      // console.log(ref)
      if (ref.ref !== null && ref.id === chartId) {
        // console.log('re-----', ref)
        return ref;
      }
    });
    // console.log(chartItem,'---', plotRef)

    // Plotly.downloadImage(plotRef, {format: 'png', width: 800, height: 600, filename: 'newplot'});

    let nodeClone = ReactDOM.findDOMNode(chartItem.ref);

    // let nodeClone = node.cloneNode(true)
    // console.log(nodeClone)
    const chartName = nodeClone.querySelector(".chart-name").innerText;
    const engageBtn = nodeClone.querySelector(".btn-engage");
    const hamburgerMenu = nodeClone.querySelector(".chart-item-menu");
    const copyButton = nodeClone.querySelector(".btn-copy");
    const modebar = nodeClone.querySelector(".modebar-container");
    const dropdown = nodeClone.querySelector(
      ".chart-dropdown.dropdown-menu.dropdown-menu-right"
    );

    dropdown.style.display = "none";
    // modebar.style.display='none'

    // if (engageBtn) {
    //   engageBtn.style.display = 'none';
    // }
    // if (hamburgerMenu) {
    //   hamburgerMenu.style.display = 'none';
    // }
    // if (copyButton) {
    //   copyButton.style.display = 'none';
    // }

    let imageTitle = `${chartName} - ${moment(new Date()).format("MM-D-YYYY")}`;

    html2canvas(plotRef).then((canvas) => {
      canvas.toBlob(function(blob) {
        // blob ready, download it
        // console.log('blob---', blob)
        let link = document.createElement("a");
        link.download = imageTitle;

        link.href = URL.createObjectURL(blob);
        link.click();

        // delete the internal blob reference, to let the browser clear memory from it
        URL.revokeObjectURL(link.href);

        if (engageBtn) {
          engageBtn.style.display = "block";
        }
        if (hamburgerMenu) {
          hamburgerMenu.style.display = "block";
        }
        if (copyButton) {
          copyButton.style.display = "block";
        }
        modebar.style.display = "block";
        // if (dropdown){
        //   dropdown.style.opacity = 0;
        // }
      }, "image/png");
    });
  };

  randomColorGenerator = () => {
    let value = Math.floor(Math.random() * 16777215).toString(16);
    let color = `#${value}`.toUpperCase();
    return color;
  };

  chartLineMarkerGenerator = (color, type, length) => {
    // let value = Math.floor(Math.random()*16777215).toString(16)
    // let color = `#${value}`.toUpperCase();
    let obj;

    if (type === "line") {
      obj = {
        color,
        width: 1,
      };
    } else {
      let marker = Math.floor(Math.random() * 9);
      let variation = Math.floor(Math.random() * 3);
      let symbol = `${chartMarkerSymbols[marker]}${chartMarkerSymbolsVariation[variation]}`;
      obj = {
        color: [...Array(length).fill(color)],
        size: 8,
        symbol,
      };
    }
    return obj;
  };

  kpiGoalValue = (chart, kpi, index) => {
    if (chart && chart.goals && chart.goals.length > 0) {
      if (kpi && kpi.kpiId && kpi.kpiId._id) {
        let result = chart.goals.filter(
          (e) =>
            e.kpiId === kpi.kpiId._id &&
            parseInt(e.name.match(/\d+/)[0]) === index + 1
        );
        if (result && result.length > 0) {
          return result[0];
        }
      }
    }
    return {};
  };

  processKpiData = (charts) => {
    const { profile } = this.props.user;
    let templateType;

    charts = chartKpiDataFieldRefTransformationMultipleCharts(charts)

    const updatedCharts = charts.map((chart, i) => {
      // chart._id = chart._id

      // console.log('chart--',chart)
      let max = 1,
        yAxisFormat,
        yRange,
        min = -0.05,
        y,
        layout,
        yAlt,
        yPercent,
        xMinDate,
        xMaxDate,
        dtickFormatVal;
      yAxisFormat = chart.yAxisFormat;
      const kpi = chart.kpiData.map((kpi, index) => {
        let goalValue = this.kpiGoalValue(chart, kpi, index);
        // console.log('gValue---', goalValue)

        const sortedKpiAggregate = sortBy(kpi.score, (kpi, i) => kpi.date);

        // console.log(sortedKpiAggregate)
        // let text = sortedKpiAggregate.map(kpi => kpi.totalEmployees?`of ${kpi.totalEmployees}`:null)
        let avgTenure = false
        let text = sortedKpiAggregate.map((val) => {
          // if(chart.yAxisFormat==='Absolute'){
          //   y = sortedKpiAggregate.map((kpi) =>  kpi.numeratorCount);

          // } else {
          //   y = sortedKpiAggregate.map((kpi) =>  Math.floor(kpi.value) /100  );
          // }
          // console.log('val---',val)
          let value_floor = Math.round(val.value);

          let textString = [];
          let ts;
          let ethnicity = val.numeratorEthnicity ? val.numeratorEthnicity : "";

          let kpiCode = kpi.kpiId.code;
        

          if (KPISbyMonth.indexOf(kpiCode) > -1) {
            // console.log('kpiMonth---',kpi)
            let t = moment.utc(val.date).format("MMMM YYYY");
            textString.push(t);
          } else {
            // console.log('kpiMonth---',kpi)
            let t = moment.utc(val.date).format("MMMM D, YYYY");
            textString.push(t);
          }

          if(val && val.avgTenure){
            avgTenure = true;
          }

          if (
            !val.numeratorCount ||
            val.numeratorCount === undefined ||
            typeof val.numeratorCount == "undefined"
          ) {
            val.numeratorCount = 0;
          }
          if (val && val.numeratorType && val.totalEmployees) {
            if (kpi.kpiId.code === "COMP-1" || kpi.kpiId.code === "COMP-2") {
              ts = ethnicity
                ? `${ethnicity} ${val.numeratorType
                    .substring(1)
                    .replace(/-/g, ", ")
                    .toLowerCase()} count: ${val.numeratorCount}${
                    yAxisFormat === "Absolute" ? ` (${value_floor}%)` : ""
                  }, male count: ${
                    val.totalEmployees
                      ? val.totalEmployees - val.numeratorCount
                      : null
                  }`
                : `${val.numeratorType
                    .substring(1)
                    .replace(/-/g, ", ")
                    .toLowerCase()} count: ${val.numeratorCount}${
                    yAxisFormat === "Absolute" ? ` (${value_floor}%)` : ""
                  }, male count: ${
                    val.totalEmployees
                      ? val.totalEmployees - val.numeratorCount
                      : null
                  }`;
              textString.push(ts);
            } else {
              ts = ethnicity
                ? `${ethnicity} ${val.numeratorType
                    .substring(1)
                    .replace(/-/g, ", ")
                    .toLowerCase()} count: ${val.numeratorCount}${
                    yAxisFormat === "Absolute" ? ` (${value_floor}%)` : ""
                  }, total: ${val.totalEmployees ? val.totalEmployees : null}`
                : `${val.numeratorType
                    .substring(1)
                    .replace(/-/g, ", ")
                    .toLowerCase()} count: ${val.numeratorCount}${
                    yAxisFormat === "Absolute" ? ` (${value_floor}%)` : ""
                  }, total: ${val.totalEmployees ? val.totalEmployees : null}`;
              textString.push(ts);
            }
          } else if (val && val.numeratorType && !val.totalEmployees) {
            ts = ethnicity
              ? `${ethnicity} ${val.numeratorType
                  .substring(1)
                  .replace(/-/g, ", ")
                  .toLowerCase()} count: ${val.numeratorCount}${
                  yAxisFormat === "Absolute" ? ` (${value_floor}%)` : ""
                }`
              : `${val.numeratorType
                  .substring(1)
                  .replace(/-/g, ", ")
                  .toLowerCase()} count: ${val.numeratorCount}${
                  yAxisFormat === "Absolute" ? ` (${value_floor}%)` : ""
                }`;
            textString.push(ts);
          } else if (val.totalEmployees && !val.numeratorType) {
            ts = `of total: ${val.totalEmployees ? val.totalEmployees : null}`;
            textString.push(ts);
          } else {
            // console.log('no value---')
            textString.push("");
            // let string= val.results&&val.results.length>0&&val.results[0].text?val.results[0].text:""
            // textStrin g.push(string)
          }

          let goalText = "";

          // if(yAxisFormat=='Absolute'){
          //   let abs_value=parseInt( e[1].match(/\d+/g)[1] )
          //   console.log()
          //   res =  parseInt(goal.number) -  Math.round(abs_value)
          // }else{
          //   res =  parseInt(goal.number) - parseInt( Math.round((scoresArray[idx])*100) )
          // }

          if (goalValue && goalValue.number) {
            let diff = parseInt(goalValue.number) - Math.round(val.value);
            let res = Math.round(diff);
            if (res > 0) {
              goalText = `Until Goal met: ${res}%`;
              textString.push(goalText);
            } else {
              goalText = `Goal reached 😀👍!`;
              textString.push(goalText);
            }
          } else {
            goalText = "";
            textString.push(goalText);
          }

          if(val.avgTenure >= 0 && val.avgTenure != null){
            const tenureString = `Avg Tenure: ${getAvgTenureFormatted(val.avgTenure)}`
            console.log("first",getAvgTenureFormatted(val.avgTenure))
          
            if(textString[2]==""){
              textString[2] = tenureString
              textString[3] = ""
            }
            else{
              textString.push(tenureString)
            }
          }else{
            textString.push("")
          }

          // console.log('text---', textString)
          return textString;
        });

        if (yAxisFormat === "Absolute") {
          y = sortedKpiAggregate.map((kpi) => kpi.numeratorCount);
          yAlt = sortedKpiAggregate.map((kpi) => Math.round(kpi.value) / 100);
        } else {
          y = sortedKpiAggregate.map((kpi) => Math.round(kpi.value) / 100);
          yAlt = sortedKpiAggregate.map((kpi) => kpi.numeratorCount);
        }

        let description = generateLegendTitle(
          kpi,
          kpi.kpiId.description,
          index,
          false,
          "",
          ""
        );
        let kpiCount = index + 1;

        sortedKpiAggregate.map((kpi) => {
          let yVal;
          if (yAxisFormat === "Absolute") {
            yVal =
              kpi.data.totalEmployees !== undefined
                ? kpi.data.totalEmployees
                : kpi.totalEmployees;
          } else {
            yVal = kpi.value / 100;
          }
          if (yVal > max) {
            max = yVal;
          }
        });

        if (yAxisFormat == "Absolute") {
          yRange = [min, max + 25];
          yAxisFormat = "Absolute";
          templateType =
            "<b>%{text[0]}</b>, " +
            `<b>%{y:.0}</b> (KPI ${kpiCount}) <br>` +
            "%{text[1]}<br>" +
            "%{text[2]}<br>" +
           "%{text[3]}<br>" +
            "<extra></extra>";
        } else {
          yRange = [min, max + 0.1];
          yAxisFormat = "";
          templateType =
            "<b>%{text[0]}</b>, " +
            `<b>%{y:.0%}</b> (KPI ${kpiCount}) <br>` +
            "%{text[1]}<br>" +
            "%{text[2]}<br>" +
          "%{text[3]}<br>"+
            "<extra></extra>";
        }
        // console.log(yRange)
        // let chartColor = this.randomColorGenerator()

        let chartColor = chartLineColor(index);

        let x = sortedKpiAggregate.map((kpi) => {
          // let date1 = new Date(kpi.date)
          // if(KPISbyMonth.indexOf(kpiCode)>-1){
          //   // console.log('kpiMonth---',kpi)
          //   let t = moment.utc(val.date).format('MMMM YYYY')
          //   textString.push(t)
          // } else {
          //   // console.log('kpiMonth---',kpi)
          //   let t = moment.utc(val.date).format('MMMM D, YYYY')
          //   textString.push(t)
          // }
          let date1 = moment.utc(kpi.date).format("YYYY-MM-DD");
          if (xMinDate == undefined || xMinDate > date1) {
            xMinDate = date1;
          }

          if (xMaxDate == undefined || date1 > xMaxDate) {
            xMaxDate = date1;
          }
          return kpi.date;
        });

        dtickFormatVal = dtickFormat(xMinDate, xMaxDate);

        return {
          // name : `KPI ${index+1}`,
          name: `${description}`,
          description,
          yAlt,
          y,
          //  sortedKpiAggregate.map((kpi) => ( Math.floor(kpi.value) /100) ),
          x,
          text,
          hovertemplate: templateType,
          type: "scatter",
          // line: plotlyLineTypes[index],
          // marker: plotlyMarkerTypes[index],
          line: this.chartLineMarkerGenerator(chartColor, "line"),
          marker: this.chartLineMarkerGenerator(chartColor, "marker", x.length),
          xaxis: "x",
          yaxis: "y",
          id: kpi.kpiId._id,
          lines: "scatter",

          // mode: x.length > 12 ? "lines" : "lines+markers",
          mode: "lines+markers",
          // marker: {
          //   size: 8,
          // },
        };
      });

      let benchmark = {};
      if (chart.benchmarkData) {
        let { industriesList } = this.state;
        let industry = find(industriesList, {
          _id: profile.organizationId.industry && profile.organizationId.industry._id ? profile.organizationId.industry._id : profile.organizationId.industry  ,
        });
        let { score } = chart.benchmarkData;
        let sortedDataArray = sortBy(score, (data) => data.date);
        const singleBenchmark = sortedDataArray.length === 1;
        benchmark.name = `Benchmark`;

        if (chart.kpiData.length === 0) {
          benchmark.description = generateLegendTitle(
            null,
            chart.category,
            0,
            true,
            industry ? industry.name : "",
            chart.benchmarkData.location
          );
        } else {
          benchmark.description = generateLegendTitle(
            chart.kpiData[0],
            chart.kpiData[0].kpiId.description,
            0,
            true,
            industry ? industry.name : ""
          );
        }

        benchmark.x = sortedDataArray.map((benchmark) => benchmark.date);
        benchmark.y = sortedDataArray.map((benchmark) => benchmark.value / 100);
        benchmark.type = "scatter";
        benchmark.line = benchmarkLineTypes[0];
        benchmark.marker = singleBenchmark
          ? plotlyMarkerTypes[3]
          : plotlyMarkerTypes[0];
        benchmark.xaxis = "x";
        benchmark.yaxis = "y";
      }

      const showEmptyLayout = checkNoDataLayoutValidity(kpi);
      if (showEmptyLayout) {
        layout = getEmptyGraphLayoutObject(
          {
            l: 45,
            r: 20,
            t: 20,
            b: 45,
          },
          28
        );
      }
      chart.benchmark = benchmark;
      chart.kpiForPlotly = kpi;
      chart.yAxisFormat = yAxisFormat;
      chart.yRange = yRange;
      chart.xMinDate = xMinDate;
      chart.xMaxDate = xMaxDate;
      chart.dtickFormat = dtickFormatVal;
      chart.layout = layout;
      // chart.kpiDescription = description
      return chart;
    });
    return updatedCharts;
  };

  handleCreateNewChart = () => {
    const analyticCategory = this.props.match.params.category;
    const category =
      find(analyticsCategories, { link: analyticCategory }) ||
      find(analyticsCategories, { name: analyticCategory });
    let link = category && category.link ? category.link : analyticCategory;
    // console.log(category, analyticCategory)
    if (link === "favorites" || link === "archive" || link === "all") {
      this.props.history.push("choose-category");
    } else {
      this.props.history.push({
        pathname: `/home/analytics/${link}/create`,
        state: {
          category: category.name,
        },
      });
    }
  };

  handleBeforeUnload = (event) => {
    event.preventDefault();
    this.props.closeDrillDownModal();
    this.props.onChartUnselected();
    // event.returnValue = true;
  };

  componentWillUnmount = () => {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  };

  componentWillReceiveProps(nextProps) {
    this.setState({ chartMessage: "" });

    if (nextProps.match.params.category !== this.props.match.params.category) {
      window.scroll(0, 0);
      let officeNode;
      if (!this.state.officeNode) {
        let hierarchy = this.props.user.profile.organizationId.staticHierarchy;
        let officeKey = this.props.user.profile.officeKey;
        officeNode = findNodeinHierarchy(hierarchy, officeKey);
        // console.log('offnode--', officeNode)
      }

      this.props.unselectChartWithNoFeedback();
      let result = nextProps.match.params.category.replace(/\+/g, " ");
      const mappedValue =
        find(analyticsCategories, { name: result }) ||
        find(analyticsCategories, { link: result });
      this.setState({
        isLoading: true,
        officeNode,
        isChartsLoaded: false,
        analyticsCategory: mappedValue.link,
        displayCharts: [],
        categoryValue: mappedValue.name,
      });

      this.getKpiListForCategory(mappedValue);

      axios
        .get(
          url.fetchAnalyticsByCategory(mappedValue.name, 0, this.getChartId())
        )
        .then(({ data }) => {
          // console.log(data)
          let isBench = data.data.benchmarkDataAvailable;
          let isData = data.data.kpiDataAvailable || data.data.length > 0;
          this.setState({
            pageNumber: 0,
            chartLength: data.meta.length,
            chartCount: data.meta.chartCount,
            notificationChart: data.meta.notificationChart
              ? this.processKpiData([data.meta.notificationChart])
              : false,
            chartMessage: "",
            isChartsLoaded: true,
          });

          if (nextProps.match.params.category === "favorites") {
            const { favList, favRemovedCount } = data.data;
            let charts = favList;
            let favLength =
              data.data.favList.length > 0 ? data.data.favList.length : 0;
            let updatedCharts = this.processKpiData(charts);
            updatedCharts = reverse(
              sortBy(updatedCharts, [
                function(chart) {
                  return chart.lastUpdate.dateTime;
                },
              ])
            );
            this.setState({
              chartLength: data.meta.length,
              displayCharts: updatedCharts,
              // allCharts: updatedCharts,
              favRemovedCount: favRemovedCount,
              isLoading: false,
              isFilterCollapsed: false,
              isKpiDataAvailableForCategory: false,
              filters: {},
              selectedSort: "last-updated",
              searchedTerm: "",
              // searchCharts: [],
            });
          } else if (Array.isArray(data.data)) {
            let charts = data.data;
            let updatedCharts = this.processKpiData(charts);
            updatedCharts = reverse(
              sortBy(updatedCharts, [
                function(chart) {
                  return chart.lastUpdate.dateTime;
                },
              ])
            );
            this.setState({
              displayCharts: updatedCharts,
              // allCharts: updatedCharts,
              isKpiDataAvailableForCategory: isData,
              isBenchmarkDataAvailableForCategory: isBench,
              filters: {},
              isFilterCollapsed: false,
              isLoading: false,
              selectedSort: "last-updated",
              searchedTerm: "",
              // searchCharts: [],
            });
          } else {
            const { benchmarkDataAvailable, kpiDataAvailable } = data.data;
            this.setState({
              displayCharts: [],
              // allCharts: [],
              // isKpiDataAvailableForCategory : kpiDataAvailable,
              isKpiDataAvailableForCategory: isData,
              isBenchmarkDataAvailableForCategory: isBench,
              filters: {},
              isFilterCollapsed: false,
              isLoading: false,
              selectedSort: "last-updated",
              searchedTerm: "",
              // searchCharts: [],
            });
          }
        })
        .catch((error) => {
          //todo show error
        });
    }
  }

  addRef = (ref, chartid) => {
    this.chartItemsRef.push({ ref: ref, id: chartid });
  };

  handleChartClick = (chart, label) => {
    const { selectedChart, currentChatId } = this.props.dani;
    // console.log('s---', selectedChart)
    if (selectedChart._id === chart._id) {
      this.props.onChartUnselected();
    } else {
      // const {displayCharts} = this.state;
      // let allCharts = [...this.state.searchCharts, ...displayCharts]
      // const chart = find(allCharts,{_id : id});
      // label = office name if changed
      // console.log(label,'-----chart----', chart)

      let selectedOffice = { ...chart.selectedOffice, label };
      chart = { ...chart, selectedOffice: { ...selectedOffice } };
      // console.log('final--', chart)
      if (currentChatId) {
        this.props.daniEngageActionClick(true);

        setTimeout(() => {
          this.props.onChartSelected(chart);
        }, 500);
      } else {
        this.props.addDaniHistoryChats({});
        this.props.daniEngageActionClick(true);

        setTimeout(() => {
          this.props.onChartSelected(chart);
        }, 500);
      }
    }
  };

  isChartSelected = (id) => {
    const { selectedChart } = this.props.dani;
    if (selectedChart._id === id) {
      return true;
    }
    return false;
  };

  handleRestoreChart = (id) => {
    const { displayCharts, analyticsCategory, categoryValue } = this.state;
    const index = findIndex(displayCharts, { _id: id });
    const chart = displayCharts[index];

    axios.put(url.restoreChart(id)).then(({ data }) => {
      chart.isArchive.value = false;
      // socketConnection.track("Restore_Click", {
      //   kpiName : chart.kpiData.map((o) => o.kpiId.name)
      // });
      if (analyticsCategory !== "favorites") {
        displayCharts.splice(index, 1);
      }

      if (analyticsCategory === "archive") {
        let chartL = this.state.chartLength - 1;
        this.setState({
          chartLength: chartL,
        });
      }

      this.setState({
        displayCharts: displayCharts,
        // allCharts: displayCharts,
      });
    });
  };

  componentWillUnmount() {
    this.props.unselectChartWithNoFeedback();
  }

  reloadChart = (id) => {
    const { displayCharts } = this.state;
    const charts = deepClone(displayCharts);
    this.setState({
      displayCharts: charts,
    });
  };

  //Handle refresh chart --- handleRefreshChart = (data, id, allOfficeKeys)
  handleRefreshChart = (results) => {
    // console.log('res---', results)
    // data.allOfficeKeys = allOfficeKeys
    axios
      .put(url.refreshChart(results._id), results)
      .then((response) => {
        let chart = response.data.data;
        let { displayCharts } = this.state;
        let updatedCharts = displayCharts;
        let updatedChart = this.processKpiData([chart]);
        updatedChart[0].isChartUpdated = true;
        const i = findIndex(updatedCharts, { _id: chart._id });
        if (i !== -1) {
          updatedCharts[i] = updatedChart[0];
        }
        //  console.log(updatedChart)
        updatedCharts = reverse(
          sortBy(updatedCharts, [
            function(chart) {
              return chart.lastUpdate.dateTime;
            },
          ])
        );
        this.setState({
          displayCharts: updatedCharts,
          // allCharts: updatedCharts,
          isLoading: false,
        });
      })
      .catch((error) => {
        console.log("err--", error);
      })
      .finally(() => window.scrollTo(0, 0));
  };

  navigateToUploadData = () => {
    const { profile } = this.props.user;
    if (profile.orgAdmin) {
      this.props.history.push("/home/upload-data");
    } else {
      this.props.history.push("/home/upload-data/manual");
    }
  };

  handleGoalDelete = (id, goal) => {
    const { displayCharts } = this.state;
    const i = findIndex(displayCharts, { _id: id });
    const displayChart = displayCharts[i];
    const j = findIndex(displayCharts, { _id: id });
    let chart = displayCharts[j];

    // console.log(goal, chart)

    if (goal && chart) {
      let goalIdx = parseInt(goal.name.match(/\d+/)[0]);
      chart.kpiForPlotly.filter((e, idx) => {
        if (e.id === goal.kpiId && goalIdx === idx + 1) {
          e.text.map((val) => {
            val[2] = "";
            return val;
          });
        }
        return e;
      });
    }

    displayCharts.splice(i, 1, { ...chart });
    // allCharts.splice(j, 1, { ...chart });

    this.setState({
      displayCharts: displayCharts,
    });
  };

  handleGoalSet = (id, goals) => {
    const { displayCharts } = this.state;
    const i = findIndex(displayCharts, { _id: id });
    const displayChart = displayCharts[i];
    // const j = findIndex(allCharts, { _id: id });
    let chart = displayCharts[i];
    let { yAxisFormat } = chart;
    // console.log(goals, chart, id)

    if (goals && goals.length > 0) {
      let goal = goals[goals.length - 1];

      let goalIdx = parseInt(goal.name.match(/\d+/)[0]);

      let kpiForPlotlySelected = chart.kpiForPlotly.filter(
        (e, idx) => e.id === goal.kpiId && goalIdx === idx + 1
      )[0];

      if (
        kpiForPlotlySelected &&
        kpiForPlotlySelected.text.length > 0 &&
        kpiForPlotlySelected.y.length > 0
      ) {
        let scoresArray = kpiForPlotlySelected.y;

        kpiForPlotlySelected.text.map((e, idx) => {
          let res;
          if (yAxisFormat == "Absolute") {
            let abs_value = parseInt(e[1].match(/\d+/g)[1]);
            res = parseInt(goal.number) - Math.round(abs_value);
          } else {
            res =
              parseInt(goal.number) -
              parseInt(Math.round(scoresArray[idx] * 100));
          }

          if (res > 0) {
            e[2] = `Until Goal met: ${res}%`;
          } else {
            e[2] = `Goal reached 😀👍!`;
          }
          return e;
        });
      }
    }

    displayCharts.splice(i, 1, { ...displayChart, goals: goals });
    // allCharts.splice(j, 1, { ...chart, goals: goals });

    this.setState({
      displayCharts: displayCharts,
      // allCharts: allCharts,
    });
  };

  toggleKPIDescriptionModal = () => {
    this.setState({
      showKPIDescriptionModal: !this.state.showKPIDescriptionModal,
    });
  };

  getMoreCharts = (filters, applied) => {
    let pageNumber = this.state.pageNumber + 1;
    let category = this.state.categoryValue;
    let cat = this.state.analyticsCategory;
    // this.setState({chartMessage:""})
    const { searchedTerm } = this.state;
    if (filters && applied) {
      pageNumber = 0;
      this.setState((prevState) => ({
        pageNumber: 0,
        chartMessage: "",
      }));
    } else {
      this.setState((prevState) => ({
        pageNumber: pageNumber,
        chartMessage: "",
      }));
    }

    filters = this.formatFilterPayload(filters);

    axios
      .get(url.fetchAnalyticsByCategory(category), {
        params: {
          ...filters,
          pageNumber,
          display: 5,
          searchedTerm: searchedTerm ? searchedTerm : undefined,
          chartId: this.getChartId() ? this.getChartId() : undefined,
        },
      })
      .then(({ data }) => {
        this.setState({ chartCount: data.meta.chartCount });
        if (cat === "favorites") {
          const { favList, favRemovedCount } = data.data;

          let charts = favList;
          let updatedCharts = this.processKpiData(charts);
          updatedCharts = reverse(
            sortBy(updatedCharts, [
              function(chart) {
                return chart.lastUpdate.dateTime;
              },
            ])
          );

          let displayCharts = applied
            ? updatedCharts
            : this.state.displayCharts.concat(updatedCharts);
          // let allCharts = applied
          //   ? updatedCharts
          //   : this.state.allCharts.concat(updatedCharts);

          this.setState({
            displayCharts,
            // allCharts,
            favRemovedCount: favRemovedCount,
            isLoading: false,
            // isFilterCollapsed: false,
            // filters: {},
            selectedSort: "last-updated",
            // searchedTerm: "",
            // searchCharts: [],
          });
        } else if (Array.isArray(data.data.data) || Array.isArray(data.data)) {
          let updatedCharts = [];
          if (Array.isArray(data.data)) {
            updatedCharts = this.processKpiData(data.data);
            this.setState({
              chartLength: data.meta.length,
            });
          }
          let chartsData = applied
            ? updatedCharts
            : updatedCharts.concat(this.state.displayCharts);

          // console.log('analytics---', chartsData)
          console.log("chartsData", chartsData.length);
          chartsData = reverse(
            sortBy(chartsData, [
              function(chart) {
                return chart.lastUpdate.dateTime;
              },
            ])
          );
          // console.log(chartsData)
          this.setState({
            displayCharts: chartsData,
            // allCharts: chartsData,
            isKpiDataAvailableForCategory: true,
            isBenchmarkDataAvailableForCategory: true,
            // filters: {},
            // isFilterCollapsed: false,
            isLoading: false,
            selectedSort: "last-updated",
            // searchedTerm: "",
            // searchCharts: [],
            chartLength: data.meta.length || 0,
          });
        } else {
          this.setState({ chartMessage: "" });
        }
      })
      .catch((error) => {
        //todo show error
        console.log("er--", error);
      });
  };

  handleScroll = (category) => {
    // const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
    // const body = document.body;
    // const html = document.documentElement;
    // console.log('scrolling ----')
    // let windowBottom = Math.ceil(windowHeight) + Math.ceil(window.pageYOffset);
    // let docHeight=html.scrollHeight
    // console.log(this.state.chartCount, this.state.chartLength)
    // console.log(window.innerHeight, document.documentElement.scrollTop, window, document.body, document.body.offsetHeight)
    if (
      window.innerHeight + document.documentElement.scrollTop !==
      document.body.offsetHeight
    )
      return;
    this.setState({ pageNumber: this.state.pageNumber + 1 });
    this.getMoreCharts(this.state.filters, false);
    // if(this.state.chartCount && this.state.chartLength) {
    //     if (this.state.searchedTerm.length===0 && this.state.searchCharts.length===0) {
    //       if(this.state.chartCount < this.state.chartLength){
    //         this.setState({chartMessage:""})
    //         this.setState({pageNumber: this.state.pageNumber+1})
    //         this.getMoreCharts()
    //     }else {
    //       this.setState({chartMessage:""})
    //     }
    //   } else {
    //     this.setState({chartMessage:""})
    //   }
    // }else {
    //     this.setState({chartMessage:""})
    // }
  };

  goToDashboard = (url) => {
    this.props.history.push(url);
  };

  updateChartPointers = (chartId, pointIndex, curveIndex) => {
    const charts_arr = [...this.state.displayCharts];

    const currentChartIndex = charts_arr.findIndex((x) => x._id == chartId);

    if (currentChartIndex >= 0) {
      let currentChartObject = charts_arr[currentChartIndex];

      const kpiForPlotlyArray = currentChartObject.kpiForPlotly ? [...currentChartObject.kpiForPlotly]:[]

      let kpiForPlotlyObject = kpiForPlotlyArray[curveIndex];

      if(kpiForPlotlyObject){
        const marker = kpiForPlotlyObject.marker;

        // marker.color = "rgb(255,0,0)"

        if(marker){
          const new_color = marker.color;
  
          new_color[pointIndex] = "rgb(255,0,0)";
    
          marker.color = deepClone(new_color);
    
          kpiForPlotlyObject = {
            ...kpiForPlotlyObject,
            marker,
          };
    
          kpiForPlotlyArray[curveIndex] = kpiForPlotlyObject;
    
          currentChartObject = {
            ...currentChartObject,
            kpiForPlotly: [...kpiForPlotlyArray],
          };
    
          charts_arr[currentChartIndex] = currentChartObject;
    
          this.setState({ displayCharts: charts_arr });
        }
  
        
      }

      
    }
  };

  resetChartPointers = () => {
    const charts = [...this.state.displayCharts];

    const newCharts = charts.map((chart) => ({
      ...chart,
      kpiForPlotly: chart.kpiForPlotly.map((kpi, idx) => ({
        ...kpi,
        marker: {
          ...kpi.marker,
          color:
            kpi.x && kpi.x.length && kpi.line
              ? [...Array(kpi.x.length).fill(kpi.line.color)]
              : chartLineColor(idx),
        },
      })),
    }));

    this.setState({ displayCharts: newCharts });
  };

  renderSingleChart = (chart, i, type) => {
    // console.log(chart, i,type)
    if (chart) {
      const { profile } = this.props.user;
      const { analyticsCategory } = this.state;
      const { selectedChart } = this.props.dani;
      //   let fixedY;
      //   let max=1.01, min = 0
      //   chart.kpiForPlotly.map((kpi) =>  kpi.y.map(val => val >max ? max = val: max  ) );
      //   chart.kpiForPlotly.map((kpi) =>  kpi.y.map(val => min < val ? min: min= val) );
      //   let yRange=[min, max]
      // if(max>1.01){
      //     max = max + 0.01
      //     yRange = [min, max]

      // }
      // else if (max < 1.0){
      //     min = min<0? min: -0.05
      //     fixedY = [min, 1.00]
      // } else if (min===0 && max===0){
      //     fixedY = [-0.1, 1.1]
      // }

      // if

      let officeId =
        chart &&
        chart.officeId != null &&
        chart.officeId != undefined &&
        chart.officeId != "undefined"
          ? chart.officeId
          : false;
      let { dashboardOptions } = this.state;
      return (
        <div
          className="chartListSingleItem"
          style={{
            border:
              selectedChart._id === chart._id
                ? "1px solid #1EC4B4"
                : type == "notificationChart"
                ? "2px solid #e83e8c"
                : "1px solid #D5D6D8",
          }}
          key={chart._id + i + chart.createdDate}
        >
          <ChartListItem
            ref={(ref) => this.addRef(ref, chart._id)}
            chart={chart}
            index={i}
            goToDashboard={this.goToDashboard}
            dashboardOptions={dashboardOptions}
            name={chart.name}
            category={analyticsCategory}
            lastUpdate={chart.lastUpdate}
            id={chart._id}
            office={officeId}
            kpiData={chart.kpiForPlotly}
            kpiChartData={chart.kpiData}
            rawData={chart.kpiData}
            kpiType={chart.kpiType}
            privacy={chart.privacy}
            useLatestDataAvailable={chart.useLatestDataAvailable}
            benchmarkData={chart.benchmark}
            benchmarkArray={chart.benchmarkData}
            createdBy={chart.createdBy}
            createdDate={chart.createdDate}
            updatedBy={chart.updatedBy}
            updatedDate={chart.updatedDate}
            canEdit={canEditChart(profile, chart)}
            canArchiveChart={canArchiveChart(profile, chart)}
            isArchived={chart.isArchive.value}
            isFavorite={chart.isFavorite}
            isChartSelected={this.isChartSelected(chart._id)}
            onAddToFavorite={this.handleAddToFavorite}
            onExportAsPng={this.handleExportAsPng}
            onArchive={this.handleArchive}
            onEdit={(id, data) => this.handleEdit(id, data)}
            onRecreate={this.handleChartRecreate}
            onChartClick={this.handleChartClick}
            isExportingToPng={this.state.isExportingToPng}
            onRestoreChart={this.handleRestoreChart}
            mappingMaster={this.props.mappingMaster}
            onMappingMasterListFetched={this.props.onMappingMasterListFetched}
            onRefreshChartClick={this.handleRefreshChart}
            reloadChart={this.reloadChart}
            yRange={chart.yRange}
            user={this.props.user}
            updateChartPointers={this.updateChartPointers}
            resetChartPointers={this.resetChartPointers}
          />
          <ChartListItemOptions
            id={chart._id}
            commentCount={chart.commentsCount}
            chartOwner={chart.createdBy}
            kpiData={chart.kpiForPlotly}
            goalData={chart.goals}
            onGoalSet={this.handleGoalSet}
            onGoalDelete={this.handleGoalDelete}
          />
        </div>
      );
    }
  };

  renderChartList = () => {
    let {
      searchCharts,
      notificationChart,
      displayCharts,
      displayType,
    } = this.state;
    let allCharts;
    console.log(displayType);
    // if (displayType == "search") {
    //   allCharts = searchCharts;
    // } else
    if (displayType == "notificationChart") {
      allCharts = notificationChart;
    } else {
      allCharts = displayCharts;
    }

    // console.log(displayType,' ----- render charts : ', allCharts)

    return allCharts.length === 0 ? (
      <div>
        <EmptyTable
          title="No results found"
          subtitle="Try rephrasing your search or changing your filters"
        />
      </div>
    ) : (
      allCharts.map((chart, i) => {
        return this.renderSingleChart(chart, i, displayType);
      })
    );
  };

  renderLoadButton = () => {
    // console.log(this.state.searchedTerm, '--1--',this.state.searchCharts, '--2--',this.state.displayCharts, '--3--',this.state.allCharts, '--4--',this.state.isChartsLoaded)

    let {
      filters,
      searchCharts,
      searchedTerm,
      displayCharts,
      allCharts,
      isChartsLoaded,
      kpiDataAvailable,
      chartCount,
      chartLength,
    } = this.state;

    let filtersLength = Object.keys(filters).length;
    if (isChartsLoaded) {
      if (
        ((displayCharts.length === 0 || chartCount > chartLength) &&
          typeof kpiDataAvailable !== "undefined") ||
        (displayCharts.length == chartLength && searchedTerm.length == 0)
      ) {
        return <div> No More Charts to Load </div>;
      } else if (
        displayCharts.length > 0
        //  &&
        // searchedTerm.length == 0 &&
        // searchCharts.length === 0 &&
        // filtersLength === 0
      ) {
        // console.log('render more button')
        return (
          <Button
            color="primary"
            className="col-lg-11 loadMoreBtn"
            onClick={() => this.getMoreCharts(this.state.filters, false)}
          >
            {" "}
            Load More{" "}
          </Button>
        );
      } else if (
        searchedTerm.length > 0 ||
        searchCharts.length > 0 ||
        searchCharts.length === 0 ||
        filtersLength > 0
      ) {
        return null;
      }
    } else {
      return null;
    }
  };

  render() {
    // console.log(this.props,'----render---', this.state)
    this.chartItemsRef = [];
    const { profile } = this.props.user;
    const {
      displayCharts,
      isFilterCollapsed,
      isKpiDataAvailableForCategory,
      searchedTerm,
      isBenchmarkDataAvailableForCategory,
      filters,
      analyticsCategory,
      selectedSort,
      isLoading,
      favRemovedCount,
      searchCharts,
      noSearchResults,
      showKPIDescriptionModal,
      kpiList,
      categoryValue,
      flatHierarchy,
      notificationChart,
    } = this.state;
    const hasNoFilters =
      searchedTerm.length === 0 && Object.keys(this.state.filters).length === 0;
    const { showDrillDownModal, selectedChart } = this.props.dani;
    let message;
    if (isLoading) {
      message = <div></div>;
    } else {
      if (displayCharts.length === 0 && hasNoFilters) {
        if (analyticsCategory === "favorites") {
          message = (
            <div
              className="text-center"
              style={{
                marginTop: "40px",
                marginBottom: "40px",
                marginLeft: "60px",
              }}
            >
              <img
                style={{ width: "371px", height: "266px" }}
                src={NoFavoritesPlaceholder}
              />
              <div
                style={{
                  fontSize: "24px",
                  color: "#54555F",
                  marginTop: "40px",
                  fontWeight: "600",
                  lineHeight: "46px",
                }}
              >
                You haven’t added any Favorites yet
              </div>
              <div
                style={{
                  fontSize: "20px",
                  color: "#54555F",
                  marginTop: "25px",
                  lineHeight: "33px",
                }}
              >
                Favorites let you personalize your Analytics. Here you can
                access charts that you find most useful, are actively working
                on, or may want to refer to frequently. As you browse and find
                charts in the Analytics or create new ones, you can add them to
                your Favorites.
              </div>
            </div>
          );
        } else if (analyticsCategory === "archive") {
          message = (
            <div
              className="text-center"
              style={{
                marginTop: "40px",
                marginBottom: "40px",
                marginLeft: "60px",
              }}
            >
              <img
                style={{ width: "371px", height: "266px" }}
                src={NoFavoritesPlaceholder}
              />
              <div
                style={{
                  fontSize: "24px",
                  color: "#54555F",
                  marginTop: "40px",
                  fontWeight: "600",
                  lineHeight: "46px",
                }}
              >
                You haven’t Archived any charts yet
              </div>
              <div
                style={{
                  fontSize: "20px",
                  color: "#54555F",
                  marginTop: "25px",
                  lineHeight: "33px",
                }}
              >
                Here you can access the archived charts. You can carry out all
                actions on the chart except for edit. You need to un-archive the
                chart in order to edit it.
              </div>
            </div>
          );
        } else {
          if (isKpiDataAvailableForCategory) {
            message = (
              <div
                className="text-center"
                style={{
                  marginTop: "40px",
                  marginBottom: "40px",
                  marginLeft: "60px",
                }}
              >
                <img
                  style={{ width: "371px", height: "266px" }}
                  src={KpiAvailablePlaceholder}
                />
                <div
                  style={{
                    fontSize: "24px",
                    lineHeight: "46px",
                    color: "#54555F",
                    fontWeight: "600",
                  }}
                >
                  {this.props.user.profile.role != "Admin" ? (
                    <span>Looks like there are no charts shared with you.</span>
                  ) : (
                    <span>Looks like there are no charts here yet.</span>
                  )}
                </div>
              </div>
            );
          } else if (isBenchmarkDataAvailableForCategory) {
            message = (
              <div
                className="text-center"
                style={{
                  marginTop: "40px",
                  marginBottom: "40px",
                  marginLeft: "60px",
                }}
              >
                <img
                  style={{ width: "371px", height: "266px" }}
                  src={NoKpiPlaceholder}
                />
                <div
                  style={{
                    fontSize: "24px",
                    lineHeight: "46px",
                    color: "#54555F",
                    marginTop: "40px",
                    fontWeight: "600",
                  }}
                >
                  Looks like your office data is not uploaded for this KPI
                  category yet.
                </div>
                {console.log({ fillll: this.state.filters })}

                {this.props.user &&
                this.props.user.profile.role == "Admin" &&
                this.props.user.profile.role !== "" ? (
                  <Button
                    color="primary"
                    style={{
                      backgroundColor: "#5099DE",
                      border: "none",
                      padding: "8px 30px",
                      marginTop: "40px",
                    }}
                    onClick={this.navigateToUploadData}
                  >
                    <span className="btn-text">Upload Data</span>
                  </Button>
                ) : null}
              </div>
            );
          } else if (
            !isBenchmarkDataAvailableForCategory &&
            !isKpiDataAvailableForCategory
          ) {
            message = (
              <div
                className="text-center"
                style={{
                  marginTop: "40px",
                  marginBottom: "40px",
                  marginLeft: "60px",
                }}
              >
                <img
                  style={{ width: "371px", height: "266px" }}
                  src={NoKpiPlaceholder}
                />
                <div
                  style={{
                    fontSize: "24px",
                    lineHeight: "46px",
                    color: "#54555F",
                    marginTop: "40px",
                    fontWeight: "600",
                  }}
                >
                  Looks like your office data is not uploaded for this KPI
                  category yet.
                </div>
                {this.props.user &&
                this.props.user.profile.role !== "User" &&
                this.props.user.profile.role !== "" ? (
                  <Button
                    color="primary"
                    style={{
                      backgroundColor: "#5099DE",
                      border: "none",
                      padding: "8px 30px",
                      marginTop: "40px",
                    }}
                    onClick={this.navigateToUploadData}
                  >
                    <span className="btn-text">Upload Data</span>
                  </Button>
                ) : null}
              </div>
            );
          }
        }
      }
    }
    const category = this.state.categoryValue;
    let isSearched =
      this.state.searchedTerm.length > 0 ||
      this.state.searchCharts.length > 0 ||
      Object.keys(filters).length > 0
        ? true
        : false;

    // console.log('render: ', searchCharts.length)
    return (
      <div className="col-md-12">
        <div className="chartCategoryTop text-size col-lg-11 col-lg-offset-1 bgWhite">
          <div className="title-text">
            Analytics: {category}
            {/* {getAnalyticsNameById(analyticsCategory)} */}
            {this.state.chartLength > 0 ? (
              <span style={{ marginLeft: "4px" }}>
                ({this.state.chartLength})
              </span>
            ) : null}
            {analyticsCategory !== "all" &&
              analyticsCategory !== "favorites" &&
              analyticsCategory !== "archive" && (
                <span onClick={this.toggleKPIDescriptionModal}>
                  <Tooltip />
                </span>
              )}
          </div>

          {(isKpiDataAvailableForCategory &&
            this.props.user.profile.role == "Admin") ||
          (this.state.chartLength > 0 &&
            this.props.user.profile.role == "Admin") ? (
            <div className="createChartBtn createChartBtnContainer">
              <Button
                color="primary"
                className="add-tool align-right"
                onClick={this.handleCreateNewChart}
              >
                <span className="createChartBtnTxt">Create a Chart</span>
              </Button>
            </div>
          ) : null}
          <div>
            <div className="p-0 col-lg-12 bgWhite chartListFilterBox">
              <div className="col-lg-10 col-md-12 col-sm-12 mb-2 searchChartsDiv">
                <InputGroup>
                  <Input
                    className="chart-search-box"
                    placeholder="Search by chart name"
                    onChange={this.searchInputDelay}
                  />
                  <InputGroupAddon addonType="append">
                    <Button
                      className="searchIconBtn"
                      style={{ maxHeight: "40px" }}
                    >
                      <i
                        style={{ color: "#818389" }}
                        className="flaticon-search"
                      ></i>
                    </Button>
                  </InputGroupAddon>
                </InputGroup>
              </div>
              <div className="col-lg-2 filter-select col-md-3 col-sm-3 pl0">
                <Button
                  color="secondary-filled"
                  onClick={this.toggleCollapse}
                  // style={{ width:'100%',height:'40px' }}
                >
                  <span className="">
                    <i
                      className="flaticon-equalizer"
                      style={{
                        fontSize: "12px",
                        marginRight: "8px",
                        color: "#3B3C41",
                      }}
                    ></i>
                    <span className="createChartBtnTxt">Filters</span>
                  </span>
                  {getAppliedFiltersCount(filters) > 0 ? (
                    <span style={{ marginLeft: "4px" }}>
                      ({getAppliedFiltersCount(filters)})
                    </span>
                  ) : null}
                </Button>
              </div>
              {/* <div className="col-lg-2 filter-select col-md-3 col-sm-3 pl0 pr10 pr0">
                <Select
                  value={selectedSort}
                  simpleValue
                  clearable={false}
                  searchable={false}
                  options={[{value : 'a-z',label:'Name A-Z'},
                  {value : 'z-a',label:'Name Z-A'},
                  {value : 'last-updated',label:'Last Updated'}]}
                  onChange={this.handleSortSelected}
                />
                </div> */}
            </div>
            <div className="row p-0 m-0 chartListContainer">
              <Collapse
                isOpen={isFilterCollapsed}
                className="col-lg-12 col-sm-12 col-md-12"
                toggler="#toggler"
                style={{ width: "100%" }}
              >
                <div className="mb-2">
                  <div>
                    <div className="row">
                      {analyticsCategory === "all" ||
                      analyticsCategory === "favorites" ||
                      analyticsCategory === "archive" ? (
                        <div className="col-lg-6 col-md-6 col-sm-9 mb-2">
                          <div
                            className="text-bolder"
                            style={{
                              fontSize: "20px",
                              lineHeight: "27px",
                              marginBottom: "10px",
                            }}
                          >
                            Category
                          </div>
                          <Select
                            name="filter-select"
                            placeholder={"Select"}
                            value={this.state.filters["category"]}
                            multi
                            simpleValue
                            onChange={(value) =>
                              this.handleFilterSelected(value, "category")
                            }
                            options={analyticsCategoryFilterValues}
                            valueKey="key"
                            labelKey="category"
                          />
                        </div>
                      ) : null}
                      <div className="col-lg-6 col-md-6 col-sm-9 mb-2">
                        <div
                          className="text-bolder"
                          style={{
                            fontSize: "20px",
                            lineHeight: "27px",
                            marginBottom: "10px",
                          }}
                        >
                          Privacy
                        </div>
                        <Select
                          name="filter-select"
                          placeholder={"Select"}
                          value={this.state.filters["createdBy"]}
                          multi
                          onChange={(value) =>
                            this.handleFilterSelected(value, "createdBy")
                          }
                          options={[
                            // {value : 'all',label:'All'},
                            { value: "PRIVATE", label: "Me Only" },
                            { value: "ENTERPRISE", label: "Enterprise" },
                            { value: "CUSTOM", label: "Shared with me" },
                          ]}
                          // options={[{value : 'OFFICE_AND_CHILDREN',label:'Offices Above Me'},
                          // {value : 'OFFICE',label:'Me and My Office'},
                          // {value : 'PRIVATE',label:'Me Only'},
                          // {value : 'All',label:'All'}]}
                        />
                      </div>
                    </div>

                    {/* filter on Office depratment */}
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-sm-9 mb-2">
                        <div
                          className="text-bolder"
                          style={{
                            fontSize: "20px",
                            lineHeight: "27px",
                            marginBottom: "10px",
                          }}
                        >
                          Office or Department
                        </div>
                        <Select
                          name="filter-select"
                          placeholder={"Select"}
                          multi
                          value={this.state.filters["office"]}
                          onChange={(value) =>
                            this.handleFilterSelected(value, "office")
                          }
                          options={flatHierarchy}
                        />
                      </div>

                      <div className="col-lg-6 col-md-6 col-sm-9 mb-2">
                        <div
                          className="text-bolder"
                          style={{
                            fontSize: "20px",
                            lineHeight: "27px",
                            marginBottom: "10px",
                          }}
                        >
                          Created By
                        </div>
                        <AssigneeDropdown
                          currentUser={this.props.user.profile}
                          taskAssignedUser={
                            this.state.filters["chartCreatedBy"]
                          }
                          editTask={() => {}}
                          removeUser={() => {
                            this.handleFilterSelected(null, "chartCreatedBy");
                          }}
                          assignedUserFormat={(user) =>
                            this.handleFilterSelected(user, "chartCreatedBy")
                          }
                          task={{
                            assignedTo: this.state.filters["chartCreatedBy"],
                          }}
                          noMargin={true}
                          helpText={"Select User"}
                        />
                      </div>
                    </div>

                    <div
                      style={{
                        marginTop: "8px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        color="secondary-filled"
                        onClick={this.toggleCollapse}
                      >
                        <span style={{ fontSize: "18px", lineHeight: "25px" }}>
                          Close Filter
                        </span>
                      </Button>
                      <span
                        style={{
                          marginLeft: "20px",
                          color: "#1679C4",
                          fontSize: "18px",
                          lineHeight: "25px",
                          cursor: "pointer",
                        }}
                        onClick={this.handleClearFilters}
                      >
                        Clear Filters
                      </span>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>
          </div>
        </div>
        {/* <hr style={{marginLeft: '15px',marginBottom:'30px'}}/> */}
        {message ? (
          message
        ) : (
          <div className="p-0 col-lg-11 col-lg-offset-1">
            {analyticsCategory === "favorites" && favRemovedCount > 0 ? (
              <div className="pl15 mt10 mb30">
                <InfoMessage
                  msg="One or more charts have been removed from your favorites."
                  subMsg="Please note when the original owner of a chart changes the privacy setting, it is no longer visible to others."
                />
              </div>
            ) : null}
            <div className="chartListItemsContainer">
              {/* {this.state.searchCharts && this.state.searchCharts.length>0? 
              <p>
                {this.state.searchCharts.length===1?
                  this.state.searchCharts.length+" result found"
                  :
                  this.state.searchCharts.length+" results found"
                } 
              </p>
              :
              null
              } */}

              {notificationChart ? this.renderChartList() : null}

              {/* {searchCharts.length==0 && noSearchResults && isSearched ?
              <div className="no_search_results_found"> No charts found </div>
            :null} */}

              {searchCharts.length > 0 && isSearched
                ? this.renderChartList()
                : this.renderChartList()}
            </div>
            <Modal isOpen={showDrillDownModal} className="drill-down-modal">
              <ModalBody style={{ paddingLeft: "25px", paddingRight: "25px" }}>
                <button
                  className="drill-down-modal-close"
                  onClick={this.props.closeDrillDownModal}
                >
                  <img src={drillDownClose} height="35px" width="35px" />
                </button>
                {this.props.dani.selectedChart &&
                this.props.dani.selectedChart.selectedOffice &&
                this.props.dani.selectedChart.selectedOffice.label ? (
                  <DrillDown
                    chartData={this.props.dani.selectedChart}
                    officeNode={this.state.officeNode}
                    yRange={this.state.yRange}
                  />
                ) : (
                  <div>
                    No Drilldown to display. Please close this pop-up and reopen
                    it by selecting "Engage" on the chart.
                  </div>
                )}
              </ModalBody>
            </Modal>
          </div>
        )}
        <KPIDescriptionModal
          chartListcategory={categoryValue}
          //  {getAnalyticsNameById(analyticsCategory)}
          showModal={showKPIDescriptionModal}
          toggle={this.toggleKPIDescriptionModal}
          kpiList={kpiList}
        />

        {this.state.chartMessage !== "" ? (
          <p> {this.state.chartMessage} </p>
        ) : null}

        {this.renderLoadButton()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    dani: state.dani,
    mappingMaster: state.mappingMaster,

  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onChartSelected: (chart) => dispatch(actionCreators.onChartSelected(chart)),
    daniEngageActionClick: (val) =>
      dispatch(actionCreators.daniEngageActionClick(val)),
    onChartUnselected: () => dispatch(actionCreators.onChartUnselected()),
    unselectChartWithNoFeedback: () =>
      dispatch(actionCreators.unselectChartWithNoFeedback()),
    closeDrillDownModal: () => dispatch(actionCreators.closeDrillDownModal()),
    onMappingMasterListFetched: (data) =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onChartDetailsCompleted: (data) =>
      dispatch(actionCreators.chartDetailsCompleted(data)),
    addDaniHistoryChats: () => dispatch(actionCreators.addDaniHistoryChats({})),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Loading(ChartList, axios))
);
